<template>
  <div class="photo-album-advanced">
    <carousel
      :swipe-on-desktop="swipeOnDesktop"
      :per-page="1"
      :carousel-identifier="carouselIdentifier"
    >
      <slot></slot>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'photo-album-advanced',
  props: {
    tagging: { type: Object, required: true },
    actions: { type: Object, required: true },
    swipeOnDesktop: { type: Boolean, default: true, required: false },
  },
  data() {
    return {
      carouselIdentifier: `carousel-${Date.now()}`,
      state: '',
      smallScreen: window.matchMedia('(max-width: 767px)').matches,
    };
  },
  mounted() {
    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on(`${this.carouselIdentifier}-pageChange`, this.noalteronPageChange);

      window.eventBus.$on('mediaquery.changed', () => {
        this.smallScreen = window.matchMedia('(max-width: 767px)').matches;
      });
    }
  },
  methods: {
    noalteronPageChange(noaltercurrentSlide, noalterprevSlide, noalterfrom) {
      if (noalterfrom === 'pagination') {
        this.state = this.actions.select;
      }

      if (
        noaltercurrentSlide - noalterprevSlide === -1 &&
        (!noalterfrom || noalterfrom === 'navigation')
      ) {
        this.state = this.actions.previous;
      } else if (
        noaltercurrentSlide - noalterprevSlide === 1 &&
        (!noalterfrom || noalterfrom === 'navigation')
      ) {
        this.state = this.actions.next;
      }

      this.label = this.noaltergetEventLabel(noaltercurrentSlide);
    },

    // ignored as jsdom doe snot understand a DOM node of type <slide>
    /* istanbul ignore next */
    noaltergetEventLabel(noaltercurrentSlide) {
      const slideNode = this.$el.querySelectorAll('.photo-album-advanced__slide')[
        noaltercurrentSlide
      ];
      let eventLabel = '';

      if (slideNode && slideNode.dataset) {
        eventLabel = slideNode.dataset && slideNode.dataset.taggingEventLabel;
      }

      return eventLabel;
    },
  },
};
</script>
